import groupDarkSvg from "../../../../../assets/common/stubs/images/ill_placeholder_group_dark.svg?dataurl";
import groupLightSvg from "../../../../../assets/common/stubs/images/ill_placeholder_group_light.svg?dataurl";
import profileDarkSvg from "../../../../../assets/common/stubs/images/ill_placeholder_profile_dark.svg?dataurl";
import profileLightSvg from "../../../../../assets/common/stubs/images/ill_placeholder_profile_light.svg?dataurl";

export const PLACEHOLDER_ASSETS = {
    profile: {
        light: profileLightSvg,
        dark: profileDarkSvg,
    },
    group: {
        light: groupLightSvg,
        dark: groupDarkSvg,
    },
};
